import React, { useState } from 'react';
import { Modal } from 'react-bootstrap';
import { FaTimes, FaExclamationCircle, FaCheckCircle } from 'react-icons/fa';
import { applyForAffiliate } from '../../Services/User/Profile';
import { showToast } from '../Toast/Toast';
import CustomButton from '../CustomButton';
import './BecomeAffiliateModal.css';

const BecomeAffiliateModal = ({ show, onHide }) => {
  const [step, setStep] = useState(1); // 1: Confirmation, 2: Success
  const [applying, setApplying] = useState(false);

  const handleConfirm = async () => {
    try {
      setApplying(true);
      const response = await applyForAffiliate();
      
      if (response.status) {
        setStep(2);
      } else {
        showToast(response.message || 'Failed to apply for affiliate', 'error');
      }
    } catch (error) {
      console.error('Error applying for affiliate:', error);
      showToast(error.message || 'Failed to apply for affiliate', 'error');
    } finally {
      setApplying(false);
    }
  };

  const handleCancel = () => {
    setStep(1);
    onHide();
  };

  const handleSuccessClose = () => {
    setStep(1);
    onHide();
  };

  const renderConfirmationStep = () => (
    <div className="affiliate-modal-content">
      <div className="affiliate-icon-wrapper">
        <FaExclamationCircle className="affiliate-icon" />
      </div>
      <h4 className="affiliate-modal-title">Become An Affiliate</h4>
      <p className="affiliate-modal-question">
        Are you sure you want to become an affiliate?
      </p>
      <div className="affiliate-modal-buttons">
        <CustomButton
          onClick={handleConfirm}
          disabled={applying}
          className="affiliate-yes-btn"
        >
          {applying ? 'Applying...' : 'Yes'}
        </CustomButton>
        <CustomButton
          onClick={handleCancel}
          variant="secondary"
          className="secondaryButton"
        >
          No
        </CustomButton>
      </div>
    </div>
  );

  const renderSuccessStep = () => (
    <div className="affiliate-modal-content">
      <div className="success-icon-wrapper">
        <FaCheckCircle className="success-icon" />
      </div>
      <h4 className="affiliate-modal-title">Successful</h4>
      <p className="success-message">
        Your request has been sent to the Admin.<br />
        After the Admin's approval you will get the<br />
        affiliate link to use.
      </p>
      <div className="affiliate-form-buttons">
        <CustomButton
          onClick={handleSuccessClose}
          className="affiliate-ok-btn"
        >
          Ok
        </CustomButton>
      </div>
    </div>
  );

  return (
    <Modal show={show} onHide={handleCancel} centered className="become-affiliate-modal">
      <Modal.Body className="affiliate-modal-body">
        <button className="modal-close-btn" onClick={handleCancel}>
          <FaTimes />
        </button>
        
        {step === 1 && renderConfirmationStep()}
        {step === 2 && renderSuccessStep()}
      </Modal.Body>
    </Modal>
  );
};

export default BecomeAffiliateModal;

